import { createFileRoute } from '@tanstack/react-router';
import { PlatformBrandingEditor } from '../../pages/platform/branding/PlatformBrandingEditor';

// Branding de la PLATAFORMA misma (no de un tenant del catálogo). La ficha platform es un
// PlatformTenantConfig más, así que su branding vive en el mismo endpoint `/tenants/{tenantId}/branding`
// con tenantId='platform'. Hereda el guard de scope PLATFORM del layout padre (_layout.platform).
export const Route = createFileRoute('/_authenticated/_layout/platform/branding')({
    component: () => <PlatformBrandingEditor tenantId="platform" />,
});
